/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [":host{width:100%;height:100%;margin:0;padding:0;border:0;display:block}.esri-attribution{font-size:10px}.esri-attribution.esri-widget{background-color:transparent}.esri-attribution__sources{align-self:end;background:rgba(255,255,255,.6);color:#333;-webkit-box-flex:unset;flex:unset}.esri-attribution__powered-by{font-size:0}.esri-attribution__link{background:url(https://js.arcgis.com/3.13/esri/images/map/logo-med.png) 0 0/contain no-repeat;display:inline-block;height:30px;width:50px}"];
export { styles as styles };
